import { NavigationGuardNext, Route } from 'vue-router';
import { getJwtToken, hasTokenExpired } from '~/api/utils';

export function isJwtTokenValid(): boolean {
  const token = getJwtToken();
  return !hasTokenExpired(token);
}

export function routeIfAuthenticated(_: Route, __: Route, next: NavigationGuardNext) {
  if (isJwtTokenValid()) {
    next({ name: 'home' });
    return;
  }
  next();
}

export function createAccountGuard(to: Route, _: Route, next: NavigationGuardNext) {
  if (to.query.token) {
    next({ name: 'create-password', query: to.query });
    return;
  }
  next();
}

export function requiresToken(route: Route, _: Route, next: NavigationGuardNext) {
  if (route.query.token) {
    next();
    return;
  }
  next({ name: 'invalid' });
}

/**
 * Auth guard checks for a valid token, if invalid redirect to login
 */
export function authGuard(_: Route, __: Route, next: NavigationGuardNext) {
  if (isJwtTokenValid()) {
    next();
    return;
  }
  next({ name: 'login' });
}
